'use client';

import React from 'react';
import { CalendarIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { match, P } from 'ts-pattern';
import { Stack } from '@zep/ui';
import { Colors } from '@zep/ui-tokens';
import { getResizedImage } from '@zep/utils';
import { SubscribePlan } from '../../../../../types';
import { OnetimePeriod } from '../../types';
import { PlanTypeWithMaxCcu } from './PlanTypeWithMaxCcu';
export const OnetimeSpaceInfo = ({
  thumbnailUrl,
  onetimePeriod,
  spaceName,
  maxCcu,
  plan
}: {
  thumbnailUrl: string;
  plan: SubscribePlan;
  spaceName: string;
  maxCcu: string;
  onetimePeriod: OnetimePeriod;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  return <>
      <div className="h-auto w-[250px] overflow-hidden rounded-xs shadow-inner md:w-[216px]">
        <img src={getResizedImage(thumbnailUrl, 216)} alt="thumbnail" className="size-full object-cover" />
      </div>
      <Stack gap={6} data-sentry-element="Stack" data-sentry-source-file="OnetimeSpaceInfo.tsx">
        <PlanTypeWithMaxCcu planType={plan} maxCcu={+maxCcu} data-sentry-element="PlanTypeWithMaxCcu" data-sentry-source-file="OnetimeSpaceInfo.tsx" />
        <div className="flex items-center gap-1.5">
          <CalendarIcon width={16} height={16} fill={Colors.Gray700} data-sentry-element="CalendarIcon" data-sentry-source-file="OnetimeSpaceInfo.tsx" />
          <span className="text-body-1-sb font-semibold text-gray-900">
            {match(onetimePeriod).with(P.when(p => /^(1[0-2]|[1-9])M$/.test(p)), () => {
            const months = onetimePeriod.replace('M', '');
            return `${months}` + t('subscription:payment.complete.months', '개월');
          }).with(P.when(p => /^[13]D$/.test(p)), () => {
            const days = onetimePeriod.replace('D', '');
            return `${days}` + t('subscription:payment.complete.days', '일');
          }).with(P.when(p => /^\d+D$/.test(p)), () => {
            const days = parseInt(onetimePeriod.replace('D', ''), 10);
            if (days >= 2 && days <= 29) {
              return `${days}` + t('subscription:payment.complete.days', '일');
            }
            return '';
          }).otherwise(() => '')}
          </span>
          <span className="text-body-1-sb font-semibold text-gray-900">
            {t('subscription:payment.complete.lumpSumType', '요금제')}
          </span>
        </div>
        <div className="max-w-[216px] truncate text-body-1 font-medium">
          {spaceName}
        </div>
      </Stack>
    </>;
};